addEventListener("DOMContentLoaded", (event) => {

    const videos = document.querySelectorAll(".video__item:not([data-video-js-initialized])");

    const playVideo = (target) => {
        let player = target.querySelector("video");
        let button = target.querySelector(".video__play");

        button.style.display = "none";
        player.play();
    };

    videos.forEach((video) => {
        video.setAttribute("data-video-js-initialized", "");

        let button = video.querySelector(".video__play");
        if (button) {
            button.addEventListener("click", () => playVideo(video));
        }
    });

});